import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

/**
 * Reveal — wraps children with scroll-reveal animation.
 *
 * Props:
 *   variant: 'up' | 'left' | 'right' | 'scale' (default 'up')
 *   delay:   number (ms) — applies a staggered delay
 *   as:      string — element tag (default 'div')
 *   className: extra classes
 */
const variantClass = {
  up: 'reveal',
  left: 'reveal-left',
  right: 'reveal-right',
  scale: 'reveal-scale',
};

export const Reveal = ({
  children,
  variant = 'up',
  delay = 0,
  as: Tag = 'div',
  className = '',
  ...rest
}) => {
  const { ref, isVisible } = useScrollReveal();
  const cls = `${variantClass[variant] || 'reveal'} ${isVisible ? 'is-visible' : ''} ${className}`.trim();
  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;
  return (
    <Tag ref={ref} className={cls} style={style} {...rest}>
      {children}
    </Tag>
  );
};

/**
 * Hook to track mouse position on a card and expose CSS vars (--mx, --my)
 * for radial-glow sheen effect.
 */
export const useSheen = () => {
  const onMouseMove = (e) => {
    const t = e.currentTarget;
    const rect = t.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    t.style.setProperty('--mx', `${x}%`);
    t.style.setProperty('--my', `${y}%`);
  };
  return { onMouseMove };
};

export default Reveal;
